import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  Row,
  Col,
  Select,
  InputNumber,
  Button,
  Space,
  useSelect,
  Collapse,
  Typography,
  Descriptions,
  Checkbox,
  Create,
  useForm,
  PageHeader,
  Breadcrumb,
  Tooltip,
  Icons,
  Divider,
  useModalForm,
  Tag,
  Alert,
  Popover,
  Spin,
  useModal as useModalRefineAntd,
  message,
} from '@pankod/refine-antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
import {
  useCreateMany,
  useGetIdentity,
  useList,
  useMany,
  useOne,
  useTable,
  useUpdate,
  useNavigation,
  useDeleteMany,
  ErrorComponent,
  useModal,
  CrudFilter,
  useCreate,
  CrudFilters,
} from '@pankod/refine-core'
import { MinusCircleOutlined, PlusOutlined, CaretRightOutlined } from '@ant-design/icons'
import {
  IProduct,
  ITestTrack,
  ISection,
  ITopic,
  ITheme,
  ISubTheme,
  ISubject,
  IPaperTemplateSubSection,
  IPaperTemplate,
  IQuestion,
  IPaper,
  IQuestionType,
  IQuestionUsageAnalysis,
  IPaperRequest,
  INotification,
  IFlaggedQuestion,
  ICleanupWindowQuestions,
} from 'interfaces'

import { useEffect, useState, lazy, Suspense, useMemo } from 'react'
import paperTemplateSubSectionMetaData from 'metadata/paperTemplateSubSections'
import paperTemplateMetaData from 'metadata/paperTemplate'
import metaData from 'metadata/paper'
import questionMetaData from 'metadata/questions'
import { CreateDraftQuestion, CreateDraftQuestionFromPaper } from 'pages/draftquestions'
import { CreatePaperWorkRequest } from './createWrFromPaper'
import { WorkRequestsFromPaperTable } from './listWorkRequestFrompaper'
import CleanupQuestionsList from './cleanupQuestions'
import { getQuestionAnswers } from 'gql/query'
import { resolveSubsectionLangs, sameLanguage } from 'helpers/paper/languageMode'
// import { PaperStats } from 'components/papers/paper_stats'

import { ShowQuestionModal } from './showQuestionModal'
import {
  createNotificationPaperApproved,
  createNotificationPaperForApproval,
  createNotificationPaperRequireAmending,
  createLogForQBReview,
} from 'gql/mutations'
import { useUserContext } from 'context/user'
import sendEmail from 'sendmail'
import Permissions from 'permissions'
import { getFlaggedQuestionData } from 'gql/query'
import { CheckUserAccess } from 'components/accessability'
import RichTextRender from 'components/questions/rich_text_render'
import { storeCopyOfQuestions } from 'helpers/paper/storeCopyOfQuestions'

const PaperStats = lazy(() =>
  import('components/papers/paper_stats').then(module => {
    return { default: module.PaperStats }
  })
)
const { Text, Link } = Typography

const { Panel } = Collapse

interface WorkRequestDetails extends IPaperTemplateSubSection {
  paperId: string
}
type Permission = {
  granted?: boolean | undefined
}

export const EditPaper: React.FC = () => {
  const { push, show, replace, goBack } = useNavigation()
  const { userRole, productManagerList } = useUserContext()
  const { data: user } = useGetIdentity()
  // const role = user?.defaultRole
  const [paperStatus, setPaperStatus] = useState('')
  const [workRequestDetails, setWorkRequestDetails] = useState<WorkRequestDetails>()
  const [questionsCreated, setQuestionsCreated] = useState(0)
  const [isLoading, setLoading] = useState<boolean>(false)
  const [flaggedQuestions, setFlaggedQuestions] = useState<string[]>([])
  const [assignedQuestions, setAssignedQuestions] = useState<string[]>([])
  const [approverFeedback, setApproverFeedback] = useState<any>([])
  const [rejectedQuestions, setRejectedQuestions] = useState<string[]>([])
  const [rejectedQuestionsFlag, setRejectedQuestionsFlag] = useState<boolean>(true)
  const [formStatusChanged, setFormStatusChanged] = useState<boolean>(false)
  const [questionFlagChanged, setQuestionFlagChanged] = useState<boolean>(false)

  const { mutate } = useUpdate<IPaperTemplate>()
  const { mutate: mutateQuestionUsageAnalysis } = useCreateMany<IQuestionUsageAnalysis>()
  const { mutateAsync: createNotification } = useCreateMany<INotification>()
  const { mutate: updatePaperRequestStatus } = useUpdate<IPaperRequest>()
  const { mutateAsync: createFlaggedQuestions } = useCreateMany<IFlaggedQuestion>()
  const { mutateAsync: deleteFlaggedQuestions } = useDeleteMany<IFlaggedQuestion>()
  const [flaggedQueExist, setFlaggedQueExist] = useState<boolean>(false)
  const [filteredFlaggedList, setFilteredFlaggedList] = useState<string[]>([])
  const { mutate: updateQuestion } = useUpdate<IQuestion>()
  const { mutate: createSendForReviewRecord } = useCreate<ICleanupWindowQuestions>()

  const [questionToReview, setQuestionToReview] = useState<string>('')
  const [currentQueIds, setCurrentQueIds] = useState<any[]>([])

  const [currentQuestionsData, setCurrentQuestionsData] = useState<IQuestion[]>([]) //send all questions list for paper stats

  //access control
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [errorCode, setErrorCode] = useState<number>(200)

  const { formProps, saveButtonProps, queryResult, form } = useForm<IPaper>({
    action: 'edit',
    metaData: metaData,
    redirect: false,
    warnWhenUnsavedChanges: true,
  })

  const record = queryResult?.data?.data
  const priorityList =
    record?.product?.type === 'jharkhand'
      ? [
          'Subject Expertise (SE)',
          'Pedagogical Content Knowledge (PCK)',
          'General Pedagogy (GP)',
          'Continuous and Comprehensive Evaluation (CCE)',
          'Teacher Perspectives and Professional Competencies (TP&PC)',
        ]
      : ['Subject Expertise (SE)', 'Pedagogical Content Knowledge (PCK)', 'General Pedagogy (GP)', 'Professional and core competencies (PC)']

  const [refresh, setRefresh] = useState(false)
  const [sortBy, setSortBy] = useState('created_at')
  const [sortOrder, setSortOrder] = useState('asc')

  const refreshData = () => {
    setSortBy('created_at')
    setSortOrder('asc')
    setRefresh(!refresh)
    // getAllWorkRequest(wrFilter, limit, offset, sortBy, sortOrder).then((resp: any) => {
    //   setTableData(resp?.work_requests)
    //   setTableTotal(resp?.work_requests_aggregate?.aggregate?.count)
    // })
  }

  const [sectionListIds, setSectionListIds] = useState<string[]>([])
  const [paperTemplateData, setPaperTemplateData] = useState<IPaperTemplate>()
  const [paperTemplateSubSectionData, setPaperTemplateSubSectionData] = useState<IPaperTemplateSubSection[]>([])
  const [subSectionQuestions, setSubSectionQuestions] = useState<any>([])
  const [sectionWiseQuestionCount, setSectionWiseQuestionCount] = useState<any>([])

  useEffect(() => {
    let questions_count = 0
    let _assignedQuestions: string[] = []
    let _flaggedQuestions = [...flaggedQuestions]
    let _approverFeedback = [...approverFeedback]
    let _rejectedQuestionsFlag = false
    subSectionQuestions?.forEach((item: any) => {
      _assignedQuestions = _assignedQuestions.concat(item?.questionIds)
      item?.questionIds?.forEach((questionId: any) => {
        if (questionId !== '') questions_count++
        if (rejectedQuestions.includes(questionId)) _rejectedQuestionsFlag = true
      })
    })
    setQuestionsCreated(questions_count)
    setAssignedQuestions(_assignedQuestions)
    setRejectedQuestionsFlag(_rejectedQuestionsFlag)
    //Resretting flagged question status to only selected questions
    _flaggedQuestions = _flaggedQuestions.filter(item => _assignedQuestions?.includes(item))
    setFlaggedQuestions(_flaggedQuestions)

    //Resetting approver feedback to only selected questions
    _approverFeedback = _approverFeedback.filter(item => _assignedQuestions?.includes(item?.questionId))
    setApproverFeedback(_approverFeedback)
  }, [subSectionQuestions])

  const { tableQueryResult: questionByTestTrackQueryResult } = useTable<IQuestion>({
    resource: 'questions',
    metaData: questionMetaData,
    hasPagination: false,
    queryOptions: { enabled: !!record?.test_track?.subject_ids && currentQueIds?.length > 0, staleTime: Infinity },
    permanentFilter: [
      { field: 'id', operator: 'in', value: currentQueIds },
      { field: 'active', operator: 'eq', value: 'true' },
    ],
  })
  const listOfQuestionByTestTrack = questionByTestTrackQueryResult?.data?.data

  const {
    formProps: createWorkRequestFormProps,
    modalProps: createWorkRequestModalProps,
    close: createWorkRequestClose,
    show: createWorkRequestShow,
  } = useModalForm({
    resource: 'work_requests',
    action: 'create',
    redirect: false,
  })

  const { modalProps: cleanupQuestionModalProps, close: closeCleanupQuestions, show: showCleanupQuestions } = useModalRefineAntd()

  // const { data: paperTemplate } = useOne<IPaperTemplate>({
  //   resource: 'paper_templates',
  //   id: record?.paper_template_id!,
  //   metaData: paperTemplateMetaData,
  //   queryOptions: {
  //     enabled: !!record?.paper_template_id,
  //   },
  // })

  //get test_event name and product name
  // const { data: testEventDataQueryResult } = useOne({ resource: 'test_events', id: record?.test_event_id!, metaData: { fields: ['name'] } })
  // const { data: productDataQueryResult } = useOne({ resource: 'products', id: record?.product_id!, metaData: { fields: ['name'] } })

  // pass this list of grade_ids to create paper drafts
  // const { data: gradeList } = useOne<ITestTrack>({
  //   resource: 'test_tracks',
  //   id: record?.test_track_id!,
  //   metaData: { fields: ['grade_ids'] },
  //   queryOptions: {
  //     enabled: !!record?.test_track_id,
  //   },
  // })

  const paperTemplateSections = useMany<ISection>({
    resource: 'sections',
    ids: sectionListIds,
    queryOptions: {
      enabled: !!sectionListIds && sectionListIds?.length > 0,
      staleTime: Infinity,
    },
    metaData: {
      fields: ['id', 'name'],
    },
  })

  if (paperTemplateSections?.data) {
    paperTemplateSections.data.data = paperTemplateSections.data.data?.sort((a: any, b: any) => {
      const indexA = priorityList.indexOf(a.name)
      const indexB = priorityList.indexOf(b.name)
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB)
    })
  }
  const findTotalQuestionCountDetails = async (ptDetails: any) => {
    //finding total count of required questions in a sections
    if (ptDetails && ptDetails?.length > 0 && subSectionQuestions?.length > 0) {
      const totalOfQuestionEachSection: any[] = Object.values(
        ptDetails.reduce((acc: any, item: any) => {
          const sectionId = item.section_id
          const count = Number(item.no_of_questions)
          const getSubsectionQuestionDetails = subSectionQuestions.find((_subsection: any) => _subsection?.id === item?.id)
          if (!acc[sectionId]) {
            acc[sectionId] = { section_id: sectionId, total: 0, existing_questions: 0 }
          }
          acc[sectionId].total += count
          acc[sectionId].existing_questions += getSubsectionQuestionDetails?.questionIds?.length || 0

          return acc
        }, {})
      )
      setSectionWiseQuestionCount(totalOfQuestionEachSection)
    }
  }

  useEffect(() => {
    //if subsectionQuestion in record came as empty array or undefined
    if (!record?.subSectionQuestions || record.subSectionQuestions.length === 0) {
      let _subSectionQuestions: any[] = []
      record?.paper_template?.paper_template?.forEach(subSection => {
        _subSectionQuestions.push({ id: subSection?.id, questionIds: subSection?.questionIds })
      })
      setSubSectionQuestions(_subSectionQuestions)
    }
  }, [record?.paper_template?.paper_template])

  useEffect(() => {
    if (!!record?.paper_template) {
      setPaperTemplateData(record?.paper_template)
      setSectionListIds(record?.paper_template?.sections)
    }
  }, [record?.paper_template])

  useEffect(() => {
    if (!!record?.paper_template?.paper_template) setPaperTemplateSubSectionData(record?.paper_template?.paper_template || [])
    if (sectionWiseQuestionCount && sectionWiseQuestionCount.length === 0) {
      findTotalQuestionCountDetails(record?.paper_template?.paper_template || [])
    }
  }, [record?.paper_template?.paper_template, subSectionQuestions])

  const handleWorkRequestModal = (subSection: any) => {
    setWorkRequestDetails({ ...subSection, paperId: record?.id })
    createWorkRequestFormProps?.form?.resetFields()
    createWorkRequestShow()
  }

  const handleQuestionFlag = (questionId: string) => {
    setQuestionFlagChanged(true)
    let _flaggedQuestions = [...flaggedQuestions]
    if (_flaggedQuestions.includes(questionId)) {
      _flaggedQuestions = _flaggedQuestions.filter(item => item !== questionId)
      setFlaggedQuestions(_flaggedQuestions)
    } else {
      _flaggedQuestions.push(questionId)
      setFlaggedQuestions(_flaggedQuestions)
    }
  }

  const handleQuestionTypeSelect = (subSectionId: string, value: any) => {
    let _subSectionQuestions: IPaperTemplateSubSection[] = [...subSectionQuestions]
    const subSectionIndex = _subSectionQuestions.findIndex(subSection => subSection?.id === subSectionId)
    let _subsection = _subSectionQuestions[subSectionIndex]
    _subsection.question_type = value
    _subSectionQuestions[subSectionIndex] = _subsection
    setSubSectionQuestions(_subSectionQuestions)
  }

  const handleQuestionSelect = (subSectionId: string, index: number, value: any) => {
    let _subSectionQuestions: IPaperTemplateSubSection[] = [...subSectionQuestions]
    const subSectionIndex = _subSectionQuestions.findIndex(subSection => subSection?.id === subSectionId)
    let _subsection = _subSectionQuestions[subSectionIndex]
    _subsection.questionIds?.splice(index, 1, value ?? '')
    _subSectionQuestions[subSectionIndex] = _subsection
    setSubSectionQuestions(_subSectionQuestions)
  }

  const handleQuestionRemove = (subSectionId: string, index: number, review?: string) => {
    let _subSectionQuestions: IPaperTemplateSubSection[] = [...subSectionQuestions]
    const subSectionIndex = _subSectionQuestions.findIndex(subSection => subSection?.id === subSectionId)
    let _subsection = _subSectionQuestions[subSectionIndex]
    const deletedQueArr = _subsection.questionIds?.splice(index, 1)
    _subSectionQuestions[subSectionIndex] = _subsection
    setSubSectionQuestions(_subSectionQuestions)
    setQuestionToReview(deletedQueArr[0])
    if (review === 'review') {
      updateQuestion({ id: deletedQueArr[0], resource: 'questions', values: { qb_permit: false } })
      createSendForReviewRecord({
        resource: 'cleanup_window_questions',
        values: { question_id: deletedQueArr[0], paper_id: record?.id, created_by: user?.id },
      })
      formProps?.form?.submit()
    }
  }

  const { data: questionToReviewResponse } = useOne<IQuestion>({
    id: questionToReview,
    resource: 'questions',
    metaData: questionMetaData,
    queryOptions: { enabled: questionToReview.length > 0, staleTime: Infinity },
  })
  const questionSentForReview = questionToReviewResponse?.data
  const revId = questionSentForReview?.id

  useEffect(() => {
    ;(async function () {
      if (revId && revId.length > 0) {
        await createLogForQBReview(user?.id, questionSentForReview?.work_request, revId, questionSentForReview?.paper)
      }
    })()
  }, [revId])

  const handleQuestionAdd = (subSectionId: string) => {
    let _subSectionQuestions: IPaperTemplateSubSection[] = [...subSectionQuestions]
    const subSectionIndex = _subSectionQuestions.findIndex(subSection => subSection?.id === subSectionId)
    let _subsection = _subSectionQuestions[subSectionIndex]
    if (_subsection?.questionIds) {
      _subsection.questionIds.push('')
    } else {
      _subsection.questionIds = ['']
    }
    _subSectionQuestions[subSectionIndex] = _subsection
    setSubSectionQuestions(_subSectionQuestions)
  }

  const handleQuestionInsight = (questionId: string, value: string) => {
    let _approverFeedback = [...approverFeedback]
    const questionIndex = _approverFeedback.findIndex(item => item?.questionId === questionId)

    if (questionIndex !== -1) {
      _approverFeedback[questionIndex].questionInsight = value
    } else {
      _approverFeedback.push({
        questionId: questionId,
        questionInsight: value,
      })
    }
    setApproverFeedback(_approverFeedback)
  }

  const handleQuestionReject = (questionId: string) => {
    let _approverFeedback = [...approverFeedback]
    const questionIndex = _approverFeedback.findIndex(item => item?.questionId === questionId)

    if (questionIndex !== -1) {
      _approverFeedback[questionIndex].questionReject = !_approverFeedback[questionIndex].questionReject ?? true
    } else {
      _approverFeedback.push({
        questionId: questionId,
        questionReject: true,
      })
    }
    setApproverFeedback(_approverFeedback)
  }

  const { tableQueryResult: flaggedQuestionQueryResult } = useTable({
    resource: 'flagged_questions',
    metaData: { fields: ['id', 'question_id', 'paper_id', 'product_id'] },
    permanentFilter: [
      { field: 'product_id', operator: 'eq', value: record?.product_id },
      { field: 'paper_id', operator: 'ne', value: record?.id },
    ],
    queryOptions: { enabled: !!record?.id, staleTime: Infinity },
  })

  const allFlaggedQuestionList = flaggedQuestionQueryResult?.data?.data

  useEffect(() => {
    let flagList: any[] = []
    setFlaggedQueExist(false)
    subSectionQuestions?.forEach((subSection: any) => {
      subSection?.questionIds?.forEach((item: string) => {
        const flaggedQueFound = allFlaggedQuestionList?.filter(eachQue => eachQue?.question_id === item)
        if (flaggedQueFound && flaggedQueFound.length > 0) {
          flagList.push(flaggedQueFound[0]?.question_id)
          setFlaggedQueExist(true)
        }
      })
    })
    setFilteredFlaggedList(flagList)
  }, [subSectionQuestions, allFlaggedQuestionList])

  const getQuestionKeys = async () => {
    let questionAnswerKeys: any[] = []
    let count = 1
    let allQuestionIds: any = []
    subSectionQuestions?.forEach((subSection: any) => {
      if (subSection?.questionIds) allQuestionIds = allQuestionIds.concat(subSection?.questionIds)
    })

    allQuestionIds = JSON.stringify(allQuestionIds)

    const questionAnswers = await getQuestionAnswers(allQuestionIds)

    subSectionQuestions?.forEach((subSection: any) => {
      subSection?.questionIds?.forEach((item: string) => {
        const option = questionAnswers?.filter((questionAnswerObj: any) => questionAnswerObj?.id === item)[0]
        const subSectionDetails = paperTemplateSubSectionData?.filter(_subSection => _subSection?.id === subSection?.id)[0]

        if (option?.questionType === 'MCQ') {
          questionAnswerKeys.push({
            number: count,
            id: item,
            questionType: option?.questionType,
            option: option?.rightOption,
            mark: subSectionDetails?.mark_per_question,
          })
        } else if (option?.questionType === 'Fill') {
          questionAnswerKeys.push({
            number: count,
            id: item,
            questionType: option?.questionType,
            answers: option.rightAnswers,
            mark: subSectionDetails?.mark_per_question,
          })
        } else {
          questionAnswerKeys.push({
            number: count,
            id: item,
            questionType: option?.questionType,
            mark: subSectionDetails?.mark_per_question,
          })
        }
        count++
      })
    })
    return questionAnswerKeys
  }

  const getRejectedQuestions = () => {
    let _rejectedQuestions: string[] = []
    approverFeedback?.forEach((item: any) => {
      if (item?.questionReject === true) _rejectedQuestions.push(item?.questionId)
    })
    return _rejectedQuestions
  }

  const disableApproveIfFeedback = (approverFeedback: any): boolean => {
    let shouldDisable = false
    approverFeedback &&
      approverFeedback.forEach((eachFeedback: any) => {
        if (eachFeedback.questionReject === true) {
          shouldDisable = true
        }
      })
    return shouldDisable
  }
  useEffect(() => {
    const getProductManagerList = async () => {
      const productManagerDetails = productManagerList?.filter((data: any) => data?.id === record?.paper_request?.created_by)
    }
    getProductManagerList()
  }, [record])

  useEffect(() => {
    setReadPermission(Permissions.can(userRole).readAny('papers'))
    setCreatePermission(Permissions.can(userRole).createAny('papers'))
    setEditPermission(Permissions.can(userRole).updateAny('papers'))
    setDeletePermission(Permissions.can(userRole).deleteAny('papers'))
  }, [userRole])

  useEffect(() => {
    if (userRole === 'productmanager') {
      if (record?.paper_request?.created_by === user?.id) {
        push(`/papers/show/${record?.id}`)
      }
    } else if (userRole === 'papersetter') {
      if (record?.status && ['For Approval', 'Approved', 'Closed']?.includes(record?.status)) push(`/papers/show/${record?.id}`)
    } else if (!editPermission?.granted && editPermission?.granted !== undefined) push('/')
    console.log(editPermission, 'readpermission')
  }, [editPermission])

  useEffect(() => {
    const code: any = CheckUserAccess('papers', 'edit', user?.id, record, userRole)
    setErrorCode(code)
  }, [userRole, user, record])

  useEffect(() => {
    if (record?.questionAnswerKeys !== undefined) {
      const allQuestionIds = record?.questionAnswerKeys?.map((q: any) => q?.id)
      console.log('question by all subjects', listOfQuestionByTestTrack)
      if (listOfQuestionByTestTrack !== undefined) {
        const currentQData = listOfQuestionByTestTrack?.filter(q => allQuestionIds?.includes(q.id))
        if (currentQData !== undefined) setCurrentQuestionsData(currentQData)
      }
    }
  }, [listOfQuestionByTestTrack])

  const handleOnFinish = async (status: string) => {
    setPaperStatus(status)
    if (status === 'For Approval') {
      const paperApproverId = record?.paper_request?.paper_approver_id
      const paperRequest = record?.paper_request
      paperApproverId && createNotificationPaperForApproval(user?.id, paperApproverId, paperRequest, record?.id)
      //include email notification here
    }
    if (status === 'Require Amending') {
      const paperSetterId = record?.paper_request?.paper_setter_id
      const paperRequest = record?.paper_request
      paperSetterId && createNotificationPaperRequireAmending(user?.id, paperSetterId, paperRequest, record?.id)
      //include email notification here
    }

    if (status === 'Approved') {
      const productManagerDetails = productManagerList?.filter(
        (data: { id: string; displayName: string; email: string }) => data?.id === record?.paper_request?.created_by
      )[0]
      let notification = {
        description: `paper ${record?.paper_smart_id} has been approved for the paper request ${record?.paper_request?.name}`,
        sender: user?.id,
        recepient: productManagerDetails?.user?.id,
        source_name: 'papers',
        title: 'Paper Approved',
        recepient_user_role: 'productmanager',
        redirect_component: 'show',
        redirect_id: record?.id,
      }

      await createNotification({ resource: 'notifications', values: [{ ...notification }] })

      await sendEmail([
        {
          subject: 'A paper has been approved.',
          to: [{ name: `${productManagerDetails?.user?.displayName}`, email: `${productManagerDetails?.user?.email}` }],
          htmlContent: `<html><body>Hi,<br/><h4> Paper with the id <strong>${record?.paper_smart_id}</strong> has been approved and ready to be used. For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
        },
      ])

      updatePaperRequestStatus({ resource: 'paper_requests', values: { status: 'Completed' }, id: record?.paper_request_id! })
      const paperSetterId = record?.paper_request?.paper_setter_id
      const paperRequest = record?.paper_request
      // paperSetterId && createNotificationPaperApproved(user?.id, paperSetterId, paperRequest, record?.id)
      let _mutationObj: any[] = []
      subSectionQuestions.forEach((item: any) => {
        const subSectionDetails = paperTemplateSubSectionData?.filter(subSection => subSection?.id === item?.id)[0]
        item?.questionIds?.forEach((questionId: string) => {
          _mutationObj.push({
            question_id: questionId,
            paper_id: record?.id,
            test_event_id: record?.test_event_id,
            section_id: subSectionDetails?.section_id,
          })
        })
      })
      mutateQuestionUsageAnalysis({
        resource: 'question_usage_analysis',
        values: _mutationObj,
      })
      const questionAnswerKeys: any = await getQuestionKeys()
      await storeCopyOfQuestions(record, questionAnswerKeys, user?.id)
    }
    formProps?.form?.submit()
  }

  const hideEdit = (record: any): boolean => {
    if (userRole !== 'papersetter' && userRole !== 'admin') {
      return true
    } else if (record?.status !== 'Unfilled Paper' && record?.status !== 'Require Amending') {
      return true
    }
    return false
  }

  // if (record?.flagged_questions) {
  //   const flaggedData = async () => {
  //     let a
  //     getFlaggedQuestionData(record?.flagged_questions).then(data => (a = data))
  //     return a
  //   }
  //   const getdata = flaggedData()
  //   console.log('gettingb', getdata)
  // }

  const onFinish = async (values: any) => {
    try {
      setLoading(true)
      console.log('saving..............................')
      const questionAnswerKeys: any = await getQuestionKeys()

      const currentRejectedQuestions = getRejectedQuestions()

      // step 1 : if a question previously rejected is reverted from rejection then existing rejected question array needs update
      let _approvedQuestion: string[] = []
      approverFeedback?.forEach((item: any) => {
        if (item?.questionReject !== true) _approvedQuestion.push(item?.questionId)
      })
      const newRejectedList = rejectedQuestions.filter(qId => !_approvedQuestion.includes(qId))
      // step 2: new rejected question to be added in the rejected list.
      const updatedRejectedList: string[] = [...newRejectedList]
      currentRejectedQuestions.forEach(qId => (newRejectedList.includes(qId) ? null : updatedRejectedList.push(qId)))

      let questionToAddRejectList: string[] = []
      currentRejectedQuestions.map(eachRejQue => {
        if (rejectedQuestions.includes(eachRejQue)) questionToAddRejectList.push(eachRejQue)
      })
      // rejectedQuestions.map(questionId => {
      //   currentRejectedQuestions.forEach(rejectedQuestion => (questionId === rejectedQuestion ? null : questionToAddRejectList.push(rejectedQuestion)))
      // })

      setFormStatusChanged(false)

      //handle flagged questions
      if (questionFlagChanged) {
        const flaggedQuestionIds: any = record?.flagged_questions
        // console.log('first', flaggedQuestionIds)
        const flaggedQueryResp: any = await getFlaggedQuestionData(flaggedQuestionIds)
        // console.log(flaggedQueryResp, 'result flag')
        const deleteQueList = flaggedQueryResp?.flagged_questions?.map((data: any) => data?.id)
        const currentFlaggedQuestionList = flaggedQuestions.map(eachQuestionId => {
          return {
            product_id: record?.product_id,
            paper_id: record?.id,
            question_id: eachQuestionId,
          }
        })
        // console.log('prev flagged ques', flaggedQuestionIds)
        // console.log('curr flagged ques', currentFlaggedQuestionList)
        if (flaggedQuestionIds?.length >= 1) {
          await deleteFlaggedQuestions({ ids: deleteQueList, resource: 'flagged_questions' })
        }
        if (currentFlaggedQuestionList?.length >= 1) {
          await createFlaggedQuestions({ resource: 'flagged_questions', values: currentFlaggedQuestionList })
        }
      }
      // removing undefined IDs from the question sub-section array
      const cleanedArraysubSectionQuestions = await subSectionQuestions.map((item: any) => {
        if (item.questionIds && Array.isArray(item.questionIds)) {
          item.questionIds = item.questionIds.filter((id: any) => id.trim() !== '')
        }
        return item
      })
      await findTotalQuestionCountDetails(record?.paper_template?.paper_template || null)
      setLoading(false)
      message.success('Your task is successfully completed')
      return (
        formProps.onFinish &&
        formProps.onFinish({
          status: paperStatus,
          subSectionQuestions: cleanedArraysubSectionQuestions, // subSectionQuestions - replaced
          questionAnswerKeys: questionAnswerKeys,
          flagged_questions: flaggedQuestions,
          approverFeedback: approverFeedback,
          rejectedQuestions: userRole === 'paperapprover' || userRole === 'admin' ? updatedRejectedList : rejectedQuestions,
        })
      )
    } catch (err) {
      setLoading(false)
      message.error('failed to complete the task')
      console.log(err, ':error from on finish method')
    }
  }

  const currentRejectedQuestions = getRejectedQuestions()
  console.log(currentRejectedQuestions, 'diffchecker', rejectedQuestions)
  console.log(approverFeedback)

  const submitForApproval = () => {
    let rejectedQuestionExist = false
    assignedQuestions.map(eachQuestion => {
      rejectedQuestions.forEach(rejQue => {
        if (eachQuestion === rejQue) rejectedQuestionExist = true
      })
    })
    return rejectedQuestionExist
  }

  useEffect(() => {
    if (record?.status) setPaperStatus(record?.status)
    //if subsection question is not empty then we changing the value of subsectionQuestion state with subsection questions from record
    if (record?.subSectionQuestions && record?.subSectionQuestions.length > 0) setSubSectionQuestions(record?.subSectionQuestions)
    if (record?.flagged_questions) setFlaggedQuestions(record?.flagged_questions)
    if (record?.approverFeedback) setApproverFeedback(record?.approverFeedback)
    if (record?.rejectedQuestions) setRejectedQuestions(record?.rejectedQuestions)
    let allQueIds: any[] = []
    if (!!record?.subSectionQuestions) {
      record?.subSectionQuestions?.forEach((subSection: any) => {
        let qArray = subSection?.questionIds
        if (qArray !== undefined && qArray?.length > 0) {
          allQueIds.push(...qArray)
        }
      })
    }
    setCurrentQueIds(allQueIds)
  }, [record])

  useEffect(() => {
    queryResult?.refetch()
  }, [userRole])

  useEffect(() => {
    return () => {
      // paperTemplateSections?.data?.data?.map((section, idx) => {
      //   const subSections = paperTemplateSubSectionData.filter((item: IPaperTemplateSubSection) => item.section_id === section?.id)
      //   subSections.forEach((subSection: any) => {
      //     form?.setFieldsValue({ subSectionQuestions: [] })
      //   })
      // })
      form?.setFieldsValue({ subSectionQuestions: [], questionAnswerKeys: [] })
      form?.resetFields()
      setSubSectionQuestions([])
      setSectionListIds([])
      setApproverFeedback([])
      setAssignedQuestions([])
      setPaperTemplateSubSectionData([])
      setPaperTemplateData(undefined)
    }
  }, [])

  return errorCode === 200 ? (
    <PageHeader
      className="site-page-header-responsive"
      ghost={false}
      title={`Edit Paper - #${record?.paper_id}-${record?.paper_smart_id}`}
      extra={[
        <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
          Back
        </Button>,
        record?.id && (
          <Button type="primary" onClick={() => showCleanupQuestions()}>
            Cleanup Questions
          </Button>
        ),
        !!record?.paper_template && (
          <Button
            key="submit for approval"
            type="primary"
            {...saveButtonProps}
            onClick={() => {
              handleOnFinish('For Approval')
            }}
            disabled={
              parseInt(record?.product?.total_questions) !== questionsCreated || rejectedQuestionsFlag || submitForApproval() || flaggedQueExist
            }
            hidden={hideEdit(record)}
          >
            Submit for Approval
          </Button>
        ),
        !!record?.paper_template && (
          <Button
            key="rquire amending"
            type="primary"
            {...saveButtonProps}
            onClick={() => {
              handleOnFinish('Require Amending')
            }}
            disabled={paperStatus !== 'For Approval'}
            hidden={userRole !== 'paperapprover' && userRole !== 'admin'}
          >
            Return for Amending
          </Button>
        ),
        !!record?.paper_template && (
          <Button
            key="show approve"
            type="primary"
            {...saveButtonProps}
            onClick={async () => {
              await handleOnFinish('Approved')
              goBack()
            }}
            disabled={
              parseInt(record?.product?.total_questions) !== questionsCreated ||
              (paperStatus !== 'For Approval' && paperStatus === 'Require Amending') ||
              disableApproveIfFeedback(approverFeedback) ||
              record?.status === 'Approved' ||
              record?.status === 'Unfilled Paper' ||
              flaggedQueExist
            }
            hidden={userRole !== 'paperapprover' && userRole !== 'admin'}
          >
            Approve
          </Button>
        ),
        //-------------------------------centa---------------------------------------------------------
        <Button key="save" type="primary" onClick={onFinish} hidden={paperStatus === 'Approved'} loading={isLoading}>
          {isLoading ? <Spin /> : 'Save'}
        </Button>,
        //-------------------------------centa---------------------------------------------------------
        // <Button key="save" type="primary" {...saveButtonProps} hidden={paperStatus === 'Approved'}>
        //   Save
        // </Button>,
      ]}
    >
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="">
          <>
            <Tag color={record?.status === 'Approved' ? 'green' : 'geekblue'}>{record?.status}</Tag>
            {rejectedQuestionsFlag && paperStatus === 'Require Amending' && userRole === 'papersetter' && (
              <Text type="danger">- (Replace rejected questions to submit for approval)</Text>
            )}
          </>
        </Descriptions.Item>
      </Descriptions>
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="Test Event Name">{record?.test_event?.name}</Descriptions.Item>
        <Descriptions.Item label="Product Name">{record?.product?.name}</Descriptions.Item>
      </Descriptions>
      <h3>Stats</h3>
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="Number of Questions Added">{`${questionsCreated}/${record?.product?.total_questions} `}</Descriptions.Item>
        {rejectedQuestions?.length > 0 && (
          <Descriptions.Item label="Approver Rejected Questions">
            {`${rejectedQuestions?.length}/${record?.product?.total_questions}`}
          </Descriptions.Item>
        )}
      </Descriptions>
      {record?.id && (userRole === 'papersetter' || userRole === 'admin') && <WorkRequestsFromPaperTable paperId={record?.id} />}
      {record?.questionAnswerKeys !== undefined ? (
        <div style={{ display: 'flex', scrollbarColor: 'red', minWidth: 200, minHeight: 200 }}>
          <Suspense fallback={<Spin />}>
            <PaperStats listOfAllQuestions={currentQuestionsData} />
          </Suspense>
        </div>
      ) : (
        <></>
      )}

      <Form
        {...formProps}
        layout="vertical"
        onFinish={values =>
          onFinish(values).then(() => {
            formProps.form?.resetFields()
            //approver
            if (paperStatus === 'Approved' || paperStatus === 'Require Amending' || paperStatus === 'For Approval') {
              if (userRole === 'paperapprover' && paperStatus === 'Approved') {
                show('papers', record?.id!)
              } else if (userRole === 'paperapprover' && paperStatus === 'Require Amending') {
                push('/papers')
              }
              //setter
              if (paperStatus === 'For Approval' && userRole === 'papersetter') {
                show('papers', record?.id!)
              }
            }
          })
        }
        onChange={() => setFormStatusChanged(true)}
        onAbort={() => {
          form.resetFields()
          setSubSectionQuestions([])
          console.log('form close triggered')
        }}
        onEnded={() => console.log('form close onended')}
      >
        <Row>
          <Col xs={24} lg={24}>
            <Row>
              <h3 style={{ marginRight: 30 }}>Paper Format</h3>

              {record?.id && <CleanupQuestionsList paperId={record?.id} modalProps={cleanupQuestionModalProps} close={closeCleanupQuestions} />}
            </Row>

            <Collapse defaultActiveKey={['0']}>
              {paperTemplateSections?.data?.data?.map((section, idx) => {
                const subSections = paperTemplateSubSectionData?.filter((item: IPaperTemplateSubSection) => item.section_id === section?.id)
                // Keep GP1, GP2, GP3... (and SE/PCK/PC) in numeric name order — Hasura return order is not guaranteed
                subSections?.sort(
                  (a, b) =>
                    parseInt(a.name.match(/\d+/)?.[0] ?? '0', 10) - parseInt(b.name.match(/\d+/)?.[0] ?? '0', 10)
                )
                const sectionCountDetails = sectionWiseQuestionCount?.find((countDetails: any) => countDetails?.section_id === section?.id)
                return (
                  <Panel header={`${section?.name} -(${sectionCountDetails?.existing_questions}/${sectionCountDetails?.total})`} key={idx}>
                    {subSections?.map((subSection: IPaperTemplateSubSection) => {
                      const _subSectionQuestions = subSectionQuestions.filter((_subsection: any) => _subsection?.id === subSection?.id)[0]
                      return (
                        <SubSections
                          key={subSection?.id}
                          subSection={subSection}
                          _subSectionQuestions={_subSectionQuestions}
                          subSections={subSections}
                          handleQuestionTypeSelect={handleQuestionTypeSelect}
                          handleQuestionAdd={handleQuestionAdd}
                          handleQuestionSelect={handleQuestionSelect}
                          handleQuestionRemove={handleQuestionRemove}
                          handleWorkRequestModal={handleWorkRequestModal}
                          handleQuestionFlag={handleQuestionFlag}
                          flaggedQuestions={flaggedQuestions}
                          assignedQuestions={assignedQuestions}
                          paperId={record?.id}
                          role={userRole}
                          handleQuestionInsight={handleQuestionInsight}
                          approverFeedback={approverFeedback}
                          handleQuestionReject={handleQuestionReject}
                          rejectedQuestions={rejectedQuestions}
                          gradeList={record?.test_track?.grade_ids}
                          record={record}
                          allFlaggedQuestionList={allFlaggedQuestionList}
                          filteredFlaggedList={filteredFlaggedList}
                          setFlaggedQueExist={setFilteredFlaggedList}
                          formProps={formProps}
                          currentQuestionsData={currentQuestionsData}
                          userDetails={user}
                        />
                      )
                    })}
                  </Panel>
                )
              })}
            </Collapse>

            <Form.Item name="updated_by" initialValue={user?.id}>
              <Input type="hidden" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {/* <CreateWorkRequesFromPaper
        modalProps={createWorkRequestModalProps}
        formProps={createWorkRequestFormProps}
        close={createWorkRequestClose}
        request={workRequestDetails!}
      /> */}
      <CreatePaperWorkRequest
        modalProps={createWorkRequestModalProps}
        formProps={createWorkRequestFormProps}
        close={createWorkRequestClose}
        request={workRequestDetails!}
        success
        refreshData={refreshData}
        gradeList={record?.test_track?.grade_ids}
      />
    </PageHeader>
  ) : (
    <ErrorComponent />
  )
}

function SubSections({
  key,
  subSection,
  _subSectionQuestions,
  subSections,
  handleQuestionTypeSelect,
  handleQuestionSelect,
  handleQuestionRemove,
  handleQuestionAdd,
  handleWorkRequestModal,
  handleQuestionFlag,
  flaggedQuestions,
  assignedQuestions,
  paperId,
  role,
  handleQuestionInsight,
  approverFeedback,
  handleQuestionReject,
  rejectedQuestions,
  gradeList,
  record,
  allFlaggedQuestionList,
  filteredFlaggedList,
  setFlaggedQueExist,
  currentQuestionsData,
  formProps,
  userDetails,
}: any) {
  const [questionModalDetails, setQuestionModalDetails] = useState()
  const [showQuestions, setShowQuestions] = useState(true)
  const [questionTypeId, setQuestionTypeId] = useState()
  const [questionList, setQuestionList] = useState<any[]>()
  const [questionViewId, setQuestionViewId] = useState<string>('')
  const [questionFilter, setQuesitonFilter] = useState<CrudFilters>([])
  const [initialQuestionList, setInitialQuestionList] = useState<IQuestion[] | undefined>()
  const [queryControl, setQueryControl] = useState<boolean>(true)

  const isInternalUser = userDetails.email.endsWith('@centa.org')
  const { base_lang, target_lang, isExpectingBilingual, isTransilation, isBaseLanguage } = resolveSubsectionLangs(subSection, record)
  // const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
  //   resource: 'question_types',
  //   fetchSize: 100,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })

  const currentFormState = formProps?.form?.getFieldsValue(true)

  // let flaggedFound = false
  // const mcqNotNullFilter: CrudFilter =
  //   questionTypeId === 'MCQ' ? { field: 'option_details', operator: 'nnull', value: true } : { field: 'id', operator: 'nnull', value: true }

  const {
    data: questionQueryResult,
    isLoading,
    refetch,
  } = useList<IQuestion>({
    liveMode: 'manual',
    resource: 'questions',
    config: {
      hasPagination: false,
      pagination: { pageSize: 1000000 },
      filters: questionFilter,
      sort: [
        {
          field: 'created_at',
          order: 'desc',
        },
      ],
    },
    queryOptions: {
      enabled: !!(!!subSection?.question_type_id && allFlaggedQuestionList && questionFilter?.length > 0 && gradeList?.length > 0 && queryControl),
    },
    metaData: {
      fields: [
        'id',
        'request_type',
        'status',
        'title',
        'question_id',
        'paper_id',
        'created_at',
        'language',
        'transilation_of',
        'variant_of',
        { bloom_level: ['name'] },
        { difficulty_level: ['name'] },
        { topic: ['name'] },
        { question_grades: ['grade_id'] },
        { questionByTransilationOf: ['language'] },
        { questionByVariantOf: ['id', 'question_id'] },
      ],
    },
  })

  const questionData = questionQueryResult?.data?.filter(question => {
    let isQuestionCompatible = false
    const questionGrades = question?.question_grades?.map(qGrade => qGrade.grade_id)
    questionGrades?.forEach(grade_id => {
      if (gradeList?.includes(grade_id)) isQuestionCompatible = true
    })
    return isQuestionCompatible
  })

  useEffect(() => {
    let filter: CrudFilters = []
    const allFlaggedIds = allFlaggedQuestionList?.map((question: any) => question?.question_id)
    if (allFlaggedIds !== undefined && questionFilter?.length === 0) {
      if (!!subSection?.topic_id) {
        filter.push({ field: 'topic_id', operator: 'eq', value: subSection?.topic_id })
      } else if (!!subSection?.sub_theme_id) {
        filter.push({ field: 'sub_theme_id', operator: 'eq', value: subSection?.sub_theme_id })
      } else if (!!subSection?.theme_id) {
        filter.push({ field: 'theme_id', operator: 'eq', value: subSection?.theme_id })
      }
      //  else if (!!subSection?.report_theme_id) {
      //   filter.push({ field: 'report_theme_id', operator: 'eq', value: subSection?.report_theme_id })
      // }
      else if (!!subSection?.subject_id) {
        filter.push({ field: 'subject_id', operator: 'eq', value: subSection?.subject_id })
      }
      if (subSection?.question_type_id === 'MCQ') filter.push({ field: 'option_details', operator: 'null', value: false })
      filter.push(
        {
          field: 'question_type_id',
          operator: 'eq',
          value: subSection?.question_type_id,
        }

        // { field: 'status', operator: 'in', value: ['Published', 'Draft', 'For Approval'] },
        // { field: 'id', operator: 'nin', value: allFlaggedIds },
        // { field: 'qb_permit', operator: 'eq', value: true }
      )
      if (!!subSection.blooms_level_id) {
        filter.push({ field: 'bloom_level_id', operator: 'eq', value: subSection?.blooms_level_id })
      }
      if (!!subSection.difficult_level_id) {
        filter.push({ field: 'difficulty_level_id', operator: 'eq', value: subSection?.difficult_level_id })
      }
      if (!!subSection.competency_id) {
        filter.push({ field: 'competency_id', operator: 'eq', value: subSection?.competency_id })
      }
      if (!!subSection.strand_id) {
        filter.push({ field: 'strand_id', operator: 'eq', value: subSection?.strand_id })
      }
      setQuesitonFilter(filter)
    }
  }, [subSection, allFlaggedQuestionList, gradeList])

  const filterOption = (input: any, option: any) => {
    const needle = String(input || '')
      .trim()
      .toLowerCase()
    if (!needle) return true
    const props = option?.props || {}
    const haystack = [option?.label, props.label, props.title, option?.value, props.value]
      .filter(value => value != null && typeof value !== 'object')
      .join(' ')
      .toLowerCase()
    return haystack.includes(needle)
  }

  useEffect(() => {
    const _questionList = questionQueryResult?.data?.filter(item => !assignedQuestions?.includes(item?.id))
    setQuestionList(_questionList)
  }, [questionQueryResult, assignedQuestions])

  // const {
  //   formProps: createQuestionFormProps,
  //   modalProps: createQuestionModalProps,
  //   show: createQuestionShow,
  // } = useModalForm({
  //   resource: 'questions',
  //   action: 'create',
  //   redirect: false,
  //   metaData: questionMetaData,
  //   async onMutationSuccess(data, variables, context) {
  //     setShowQuestions(false)
  //     // refetch()
  //     setShowQuestions(true)
  //   },
  // })

  const {
    formProps: createDraftQueFormProps,
    modalProps: createDraftQueModalProps,
    show: createDraftQueShow,
  } = useModalForm({
    resource: 'questions',
    action: 'create',
    redirect: false,
    metaData: questionMetaData,
    queryOptions: { enabled: !!'' },
    async onMutationSuccess(data, variables, context) {
      setShowQuestions(false)
      console.log('THIS IS POST DRAFT QUESTION RESPONSE')
      setShowQuestions(true)
      setTimeout(() => {
        setQueryControl(true)
      }, 3000)
      refetch()
    },
  })
  createDraftQueModalProps.width = '100%'
  const {
    modalProps: questionShowModalProps,
    formProps: questionShowFormProps,
    show: questionModalShow,
    close: questionModalClose,
  } = useModalForm({ action: 'clone', resource: 'questions', metaData: questionMetaData, warnWhenUnsavedChanges: false })

  const handleQuestionTypeChange = (value: any) => {
    setQuestionTypeId(value)
    handleQuestionTypeSelect(subSection.id, value)

    refetch()
  }

  const selectableQuestions = questionData

  const handleDraftQueModal = (subSection: any) => {
    setQuestionModalDetails({ ...subSection, paperId: paperId, paper_id: record?.paper_id, selectableQuestions })
    createDraftQueFormProps?.form?.resetFields()
    createDraftQueShow()
    setQueryControl(false)
  }

  let formListInitialValue: any = []
  _subSectionQuestions?.questionIds?.forEach((item: string) => {
    formListInitialValue.push({
      question_id: item,
    })
  })

  useEffect(() => {
    setQuestionTypeId(subSection?.question_type_id ?? _subSectionQuestions?.question_type)
  }, [subSection?.question_type, _subSectionQuestions?.question_type])

  useEffect(() => {
    if (Array.isArray(questionQueryResult?.data)) {
      const questionData: IQuestion[] =
        questionQueryResult?.data?.filter(question => {
          let isQuestionCompatible = false
          const questionGrades = question?.question_grades?.map(qGrade => qGrade.grade_id)
          questionGrades?.forEach(grade_id => {
            if (gradeList?.includes(grade_id)) isQuestionCompatible = true
          })
          return isQuestionCompatible
        }) || []
      // console.log(questionData, '-->')
      setInitialQuestionList([...questionData])
    }
  }, [questionQueryResult?.data])

  useEffect(() => {
    return () => {
      refetch()
      setQuestionList([])
    }
  }, [])

  return (
    <>
      {/* <Collapse defaultActiveKey={[`Panel-${subSections[0].id}`]} expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}> */}
      <Collapse
        defaultActiveKey={subSections.map((subSection: any) => `Panel-${subSection.id}`)}
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
      >
        <Panel
          // header={`Sub-Section : ${subSection?.name}`}
          header={
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>Sub-Section: {subSection?.name}</span>
              {isExpectingBilingual && <Tag color="green">Bilingual</Tag>}
            </div>
          }
          key={`Panel-${subSection?.id}`}
          style={{ marginBottom: '10px' }}
        >
          <Descriptions size="small" column={3}>
            {/* <Descriptions.Item label="Section id">{subSection?.id ?? ''}</Descriptions.Item> */}
            <Descriptions.Item label="Section Name">{subSection?.name ?? 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Subject">{subSection?.subject?.name ?? 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Report Theme">{subSection?.report_theme?.name ?? 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Theme">{subSection?.theme?.name ?? 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Sub Theme">{subSection?.sub_theme?.name ?? 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Topic">{subSection?.topic?.name ?? 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Blooms Level">{subSection?.bloom_level?.name || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Difficulty Level">{subSection?.difficulty_level?.name || 'N/A'}</Descriptions.Item>
            {subSection?.competency?.name && <Descriptions.Item label="Competency">{subSection?.competency?.name || ''}</Descriptions.Item>}
            {subSection?.strand?.name && <Descriptions.Item label="Strand">{subSection?.strand?.name || ''}</Descriptions.Item>}
            <Descriptions.Item label="Number of Questions">{`${subSection?.no_of_questions ?? 'N/A'}`}</Descriptions.Item>
            <Descriptions.Item label="Mark per Question">{subSection?.mark_per_question ?? 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Question Type ID">{subSection?.question_type_id ?? 'N/A'}</Descriptions.Item>
            {(base_lang || target_lang) && (
              <Descriptions.Item label="Language">
                {isExpectingBilingual
                  ? `${base_lang.toUpperCase()} - ${target_lang.toUpperCase()}`
                  : target_lang
                  ? `${target_lang.toUpperCase()}-(transilation)`
                  : base_lang.toUpperCase()}
              </Descriptions.Item>
            )}
          </Descriptions>
          <Row gutter={[16, 0]}>
            {!subSection?.question_type_id || subSection?.question_type_id === '' || subSection?.question_type_id === null ? (
              <Col xs={24} lg={8}>
                <Form.Item
                  label="Question Type"
                  name="question_type"
                  initialValue={subSection?.question_type_id ?? _subSectionQuestions?.question_type}
                  rules={[{ required: true }]}
                >
                  <Select
                    onChange={value => {
                      handleQuestionTypeChange(value)
                    }}
                    // {...questionTypeSelectProps}
                  />
                </Form.Item>
              </Col>
            ) : null}
          </Row>

          <div style={{ textAlign: 'left', margin: '0 0 12px 0' }}>
            <Button
              key="create work request"
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                handleWorkRequestModal(subSection)
              }}
              hidden={role !== 'papersetter' && role !== 'admin'}
            >
              Create Work Request
            </Button>
            {/* <Button
              key="create question"
              type="primary"
              style={{ marginLeft: ' 10px' }}
              icon={<PlusOutlined />}
              onClick={() => {
                handleQuestionModal(subSection)
              }}
              hidden={role !== 'papersetter' && role !== 'admin'}
            >
              Create New Question
            </Button> */}
            <Button
              key="create draft question"
              type="primary"
              style={{ marginLeft: ' 10px' }}
              icon={<PlusOutlined />}
              onClick={() => {
                handleDraftQueModal(subSection)
              }}
              hidden={role !== 'papersetter' && role !== 'admin'}
            >
              Create New Draft Question
            </Button>
          </div>

          <Divider style={{ margin: ' 0' }} />
          <b>Stats</b>
          <Descriptions size="small" column={3}>
            <Descriptions.Item label="Number of Questions Added">{`${_subSectionQuestions?.questionIds?.length || 0} of ${
              subSection?.no_of_questions
            }`}</Descriptions.Item>
            <Descriptions.Item label="Total Marks">{`${_subSectionQuestions?.questionIds?.length * subSection?.mark_per_question || 0} of ${
              subSection?.no_of_questions * subSection?.mark_per_question
            }`}</Descriptions.Item>
          </Descriptions>
          <Divider style={{ margin: '0 0 12px' }} />

          <Form.List name={subSection.id} initialValue={formListInitialValue}>
            {(fields, { add, remove }, { errors, warnings }) => {
              return (
                <>
                  {fields.map(({ key, name, ...restField }, idx) => {
                    const approverInsight = approverFeedback.filter((item: any) => item?.questionId === _subSectionQuestions?.questionIds[idx])[0]
                      ?.questionInsight
                    const approverRejected = approverFeedback.filter((item: any) => item?.questionId === _subSectionQuestions?.questionIds[idx])[0]
                      ?.questionReject
                    const questionId = _subSectionQuestions?.questionIds?.[idx]

                    const queData = currentQuestionsData?.filter((que: any) => que?.id === questionId)[0]
                    const isQueinCleanup = queData?.qb_permit === false && queData?.status !== 'Retired'

                    // if (filteredFlaggedList.includes(questionId)) {
                    //   flaggedFound = true
                    //   setFlaggedQueExist(flaggedFound)
                    // }
                    return (
                      <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                        {flaggedQuestions && !filteredFlaggedList?.includes(questionId) && (
                          <Tooltip title="Flag question to be unusable anywhere else in this product.">
                            <Form.Item>
                              <Checkbox
                                checked={flaggedQuestions?.includes(questionId)}
                                onChange={() => handleQuestionFlag(questionId)}
                                children={
                                  <Text strong code>
                                    Flagging
                                  </Text>
                                }
                              />
                            </Form.Item>
                          </Tooltip>
                        )}

                        {showQuestions && (
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Form.Item
                              {...restField}
                              name={[name, 'question_id']}
                              rules={[{ required: true, message: 'Missing Question' }]}
                              style={{ width: 600 }}
                            >
                              <Select
                                size="large"
                                showSearch
                                optionFilterProp="label"
                                disabled={record?.status === 'Require Amending' && !rejectedQuestions?.includes(questionId)}
                                placeholder="Select Question"
                                onChange={value => handleQuestionSelect(subSection.id, idx, value)}
                                filterOption={filterOption}
                                allowClear
                                //paper approver assigning questions & approve
                                // disabled={role === 'paperapprover'}
                              >
                                {questionQueryResult?.data

                                  ?.filter(question => {
                                    let isQuestionCompatible = false
                                    let isCreatedQuestion = question.request_type === 'Q'
                                    //if its not internal user, he have to take only Published questions
                                    if (isInternalUser) {
                                      if (isCreatedQuestion) {
                                        const statusValues = ['Published', 'Draft', 'For Approval']
                                        let isCreatedQuestionHaveStatus = !statusValues.includes(question.status)
                                        if (isCreatedQuestionHaveStatus) return false
                                      }
                                    } else {
                                      if (question.status !== 'Published') return false
                                    }
                                    if (isExpectingBilingual) {

                                      if (
                                        !question?.transilation_of ||
                                        !sameLanguage(question?.language, target_lang) ||
                                        !sameLanguage(question?.questionByTransilationOf?.language, base_lang)
                                      )
                                        return false
                                    }
                                    if (isTransilation) {
                                      if (!question?.transilation_of || !sameLanguage(question?.language, target_lang)) return false
                                    }
                                    if (isBaseLanguage) {
                                      if (question?.transilation_of || !sameLanguage(question?.language, base_lang)) return false
                                    }
                                    const questionGrades = question?.question_grades?.map(qGrade => qGrade.grade_id)
                                    questionGrades?.forEach(grade_id => {
                                      if (gradeList?.includes(grade_id)) isQuestionCompatible = true
                                    })

                                    return isQuestionCompatible
                                    // }
                                    // else{
                                    // return true
                                    // }
                                  })
                                  ?.map((item: any) => {
                                    if (!assignedQuestions?.includes(item?.id) || questionId === item?.id)
                                      return (
                                        <Select.Option
                                          key={item.id}
                                          value={item.id}
                                          title={`${item.question_id}`}
                                          label={`${item.question_id} ${item.language || ''} ${item.title || ''}`}
                                          style={{ backgroundColor: item?.variant_of ? '#fffbc7' : '' }}
                                        >
                                          <Tooltip
                                            // content={<div>{item?.title}</div>}
                                            // title={item?.title}
                                            title={`${item?.variant_of ? `V-${item?.variant_of} | ` : ``}B-${item?.bloom_level?.name} | D-${item?.difficulty_level?.name} | T-${
                                              item?.topic?.name ? item?.topic?.name : 'N/A'
                                            } | Q-${item?.title}`}
                                            style={{ position: 'fixed', zIndex: 9999 }}
                                          >
                                            <Space align="baseline">
                                              {`#${item?.question_id} `}
                                              <RichTextRender content={item?.title} key={item?.id} styles={{ width: 'max', height: '50px' }} />
                                              {`${item?.paper_id === paperId ? '**' : ''}`}
                                            </Space>
                                            {/* {`#${item?.question_id}`} */}
                                            {/* <RichTextRender
                                              prefixContent={`#${item?.question_id}-`}
                                              content={item?.title}
                                              suffixContent={`${item?.paper_id === paperId ? '**' : ''}`}
                                              key={item?.id}
                                              styles={{ width: '120px', height: '50px' }}
                                            /> */}
                                            {/* {item?.paper_id === paperId && '**'} */}
                                            {/* {`#${item?.question_id} - ${item?.title}`} {item?.paper_id === paperId && '**'} */}
                                          </Tooltip>
                                        </Select.Option>
                                      )
                                  })}
                              </Select>
                            </Form.Item>

                            {rejectedQuestions?.includes(questionId) && <Text type="danger">Rejected Question</Text>}
                          </div>
                        )}

                        <Icons.EyeOutlined
                          style={{ fontSize: 'large' }}
                          onClick={() => {
                            setQuestionViewId(questionId)
                            questionModalShow()
                          }}
                        />
                        {(role === 'paperapprover' || role === 'admin') && record?.status === 'For Approval' && (
                          <>
                            <Form.Item>
                              <Input
                                placeholder="Question Insight"
                                type="small"
                                value={approverInsight ?? ''}
                                onChange={e => handleQuestionInsight(questionId, e.target.value)}
                              />
                            </Form.Item>
                            <Button danger type={approverRejected ? 'dashed' : 'default'} onClick={() => handleQuestionReject(questionId)}>
                              {approverRejected ? 'Undo rejection' : 'Reject'}
                            </Button>
                          </>
                        )}

                        <MinusCircleOutlined
                          onClick={() => {
                            remove(name)
                            handleQuestionRemove(subSection.id, idx)
                          }}
                          disabled={role === 'paperapprover'}
                        />
                        {!!questionId && !flaggedQuestions?.includes(questionId) && !filteredFlaggedList?.includes(questionId) && !isQueinCleanup && (
                          <Tooltip title="Send the question to cleanup window">
                            <Button
                              hidden={role !== 'papersetter' && role !== 'admin'}
                              size="small"
                              onClick={() => {
                                remove(name)
                                handleQuestionRemove(subSection.id, idx, 'review')
                              }}
                            >
                              Send for Review
                            </Button>
                          </Tooltip>
                        )}
                        {filteredFlaggedList?.includes(questionId) && <Tag color="red">Flagged</Tag>}
                        {queData?.status === 'Retired' && <Tag color="red">Retired</Tag>}
                        {isQueinCleanup && <Tag color="red">In Cleanup</Tag>}
                        {role === 'papersetter' ? <Text type="danger">{approverInsight}</Text> : null}
                      </Space>
                    )
                  })}
                  <Form.Item>
                    <Button
                      type="dashed"
                      disabled={_subSectionQuestions?.questionIds?.length >= subSection?.no_of_questions}
                      onClick={() => {
                        add()
                        handleQuestionAdd(subSection.id)
                      }}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Question
                    </Button>
                  </Form.Item>
                  <Form.ErrorList errors={errors} />
                </>
              )
            }}
          </Form.List>
        </Panel>
      </Collapse>
      {/* <CreateDraftQuestion
        modalProps={createQuestionModalProps}
        formProps={createQuestionFormProps}
        data={questionModalDetails}
        gradeList={gradeList}
      /> */}
      <CreateDraftQuestionFromPaper
        formProps={createDraftQueFormProps}
        modalProps={createDraftQueModalProps}
        request={questionModalDetails}
        gradeList={gradeList}
      />
      <ShowQuestionModal
        modalProps={questionShowModalProps}
        formProps={questionShowFormProps}
        close={questionModalClose}
        questionId={questionViewId}
      />
    </>
  )
}
